//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SecurityIcon from '@material-ui/icons/Security';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SendIcon from '@material-ui/icons/Send';
import io from 'socket.io-client';
import Divider from "@material-ui/core/Divider";



 /* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    card: {
        maxWidth: 600,
        backgroundColor:'#e9eef2',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },
    dividerColor1: {
        //marginTop: theme.spacing.unit * 3,
        color:"#40a339",
        backgroundColor:"#40a339",
    },

});


//'url(' + require('../../images/IMG_1.JPG')
class ExpandableMessage extends React.Component {

            constructor(props) {
                super(props);
                this.state = {
                    age: '',
                    name: 'Farshid',
                    testnumber: '1232322',
                    labelWidth: 0,
                    open:false,
                };
                //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
                this.deleteImageClick = this.deleteImageClick.bind(this);
                this.editImageClick = this.editImageClick.bind(this);
                this.handleClickOpen = this.handleClickOpen.bind(this);
                this.handleClose = this.handleClose.bind(this);
                this.PaperComponent = this.PaperComponent.bind(this);
                

            }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


            render() {
            const {classes} = this.props;
               // const classes2 = useStyles();
                var pdispatchtime="---";
                if((this.props.info.messagetime != null)  || (this.props.info.messagetime != undefined)) {
                    pdispatchtime = new Date(this.props.info.messagetime);
                    var hour1 = pdispatchtime.getHours() % 12;
                    var newformat1 = pdispatchtime.getHours() >= 12 ? 'PM' : 'AM';
                    var minutes = pdispatchtime.getMinutes() < 10 ? '0' + pdispatchtime.getMinutes() : pdispatchtime.getMinutes();
                    pdispatchtime = (pdispatchtime.getMonth() + 1) + "/" + pdispatchtime.getDate() + "/" + pdispatchtime.getFullYear() + " " + hour1 + ":" + minutes + " " + newformat1;
                }

            return (
                < ExpansionPanel  className={classes.card}>
                    < ExpansionPanelSummary expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
                    <Grid container spacing={24}>
        
                    <Grid item xs={2} sm={2}>
                    <SendIcon fontSize="large" color="primary"></SendIcon>
        
                    </Grid>
                    <Grid item xs={10} sm={10}>
                    <div>
                    < Typography  style={{display: 'inline-block'}}
                variant = "h6" >
                    {this.props.info.state} - {this.props.info.actionTaken}
                < /Typography>
                </div>
                </Grid>
                    </Grid>
                    
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                            <Grid container spacing={24}>
                    
                                <Grid item xs={6} sm={6}>
                                        < Typography   style={{display: 'inline-block' , textDecoration: 'underline'}}
                                            variant = "subtitle2"
                                        >

                                        Time :
                                < /Typography>
                                        <br/>
                                    < Typography  style={{display: 'inline-block',fontWeight:'fontWeightBold' , marginLeft: 15}}
                                        variant="subtitle1"
                                        >
                                        {pdispatchtime}
                                        < /Typography>
                                </Grid>


                            <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block'}}
                                variant = "subtitle2"
                                 >
                                   Plate Number:
                            < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                variant = "subtitle1"
                                 >
                                    {this.props.info.vehicleplatenumber}
                                < /Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block'}}
                                        variant = "subtitle2" >
                                    Location:
                                    < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "subtitle1" >
                                    {this.props.info.vehiclelocation}
                                < /Typography>
                            </Grid>


                        
                     
                          

                     
                            <Grid item xs={6} sm={6}>
                                < Typography  style={{display: 'inline-block'}}
                                variant = "button" >
                                        Storage:
                                < /Typography>
                                    <br/>
                                    < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "body1" >
                                        {this.props.info.storagelot}
                                < /Typography>
                                </Grid>
                                
                                        </Grid>
                
                </ExpansionPanelDetails>
    
                </ExpansionPanel>
                
               
        )
            ;
        }//end of render
}//End of class

ExpandableMessage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpandableMessage);
